$(window).load(function () {

	$('.hero-gallery').flickity({
		// options
		cellAlign: 'left',
		pageDots: false,
		contain: true,
		autoPlay: true,
	});

	$('.slide-gallery').flickity({
		// options
		cellAlign: 'left',
		pageDots: false,
		contain: true,
	});

	$('.carousel').flickity({
		// options
		cellAlign: 'left',
		prevNextButtons: false,
		contain: true,
	});

	//ISOTOPE GALLERY

	var $container = $('ul#isotope-gallery');
	$container.isotope({
		itemSelector: 'li',
	});

	$(window).bind('resize load', function () {
		$container.isotope('reLayout');
	});
});

$(document).ready(function () {

	// Print content area

	$('.print-this').click(function () {
		// Print the DIV.
		$('.print-content').print({
			addGlobalStyles: true,
			stylesheet: null,
			rejectWindow: true,
			noPrintSelector: '.no-print',
			iframe: true,
			append: '<h2>NATIONAL PHOTONICS INITIATIVE</h2>',
			prepend: null,
		});
	});

	$('.video-responsive').fitVids();

	$('.flexnav').flexNav({
		animationSpeed: 250, // default for drop down animation speed
		transitionOpacity: true, // default for opacity animation
		buttonSelector: '.menu-button', // default menu button class name
		hoverIntent: false, // Change to true for use with hoverIntent plugin
		hoverIntentTimeout: 150, // hoverIntent default timeout
		calcItemWidths: false, // dynamically calcs top level nav item widths
		hover: true, // would you like hover support?
	});

	/* Smooth scroll */

	//Check to see if the window is top if not then display button
	$(window).scroll(function () {
		if ($(this).scrollTop() > 400) {
			jQuery('.scroll-to-top').fadeIn();
		} else {
			$('.scroll-to-top').fadeOut();
		}
	});

	//Click event to scroll to top
	$('.scroll-to-top').click(function () {
		$('html, body').animate({ scrollTop: 0 }, 800);
		return false;
	});

	// svg expend

	$('img.svg').each(function () {
		var $img = $(this);
		var imgID = $img.attr('id');
		var imgClass = $img.attr('class');
		var imgURL = $img.attr('src');

		$.get(
			imgURL,
			function (data) {
				// Get the SVG tag, ignore the rest
				var $svg = $(data).find('svg');

				// Add replaced image's ID to the new SVG
				if (typeof imgID !== 'undefined') {
					$svg = $svg.attr('id', imgID);
				}
				// Add replaced image's classes to the new SVG
				if (typeof imgClass !== 'undefined') {
					$svg = $svg.attr('class', imgClass + ' replaced-svg');
				}

				// Remove any invalid XML tags as per http://validator.w3.org
				$svg = $svg.removeAttr('xmlns:a');

				// Replace image with new SVG
				$img.replaceWith($svg);
			},
			'xml'
		);
	});

	// hover class to boxes

	$('.hoverbox').click(function () {
		// get the href
		var thisHref = $(this).find('a').attr('href');

		location.href = thisHref;
	});

	/************** full hovers **************/
	$('.hoverlink').hover(function () {
		$(this).parent().toggleClass('hover');
	});

	$('.article-header').hover(function () {
		$(this).toggleClass('hover');
	});

	$('.hover-box').hover(function () {
		$(this).toggleClass('hover');
	});

	// Disable default behaviour on href='#' links
	$('a').click(function () {
		if ($(this).attr('href') === '#') {
			event.preventDefault();
		}
	});

	/*
    Responsive $ is a tricky thing.
    There's a bunch of different ways to handle
    it, so be sure to research and find the one
    that works for you best.
    */

	/* getting viewport width */
	var responsive_viewport = $(window).width();

	/* if is below 481px */
	if (responsive_viewport < 481) {
	} /* end smallest screen */

	/* if is larger than 481px */
	if (responsive_viewport > 481) {
	} /* end larger than 481px */

	/* if is above or equal to 768px */
	if (responsive_viewport >= 768) {
	}

	/* off the bat large screen actions */
	if (responsive_viewport > 1030) {
	}
});
